<!--src/components/Common/UserInfoCard.vue-->
<template>
  <div
    class="user-info-card"
    style="width: 95%; margin: 20px auto; border: 1px solid #eee; padding: 20px; border-radius: 10px; background: #fff;"
  >
    <div class="user-info-row">
      <!-- 头像：使用解析后的本地路径，带多层兜底 -->
      <div class="user-avatar">
        <img
          :src="parsedAvatarUrl"
          alt="头像"
          style="width: 60px; height: 60px; border-radius: 50%;"
          @error="handleAvatarError"
        >
      </div>
      <!-- 用户信息 -->
      <div class="user-details">
        <div class="user-name-row">
          <span class="user-nickname">
            {{ userStore.userInfo.nickname || '未登录' }}
          </span>
          <!-- 会员等级徽章 -->
          <span
            v-if="hasLogin"
            class="level-badge"
            :class="getLevelClass(userStore.userInfo.level)"
          >
            {{ getLevelText(userStore.userInfo.level, userStore.userInfo.title) }}
          </span>
        </div>
        <div
          v-if="userStore.userInfo.phone"
          class="user-phone"
        >
          {{ userStore.userInfo.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}
        </div>
      </div>
      <!-- 登录/退出按钮 -->
      <div class="user-action">
        <button
          style="width: 100px; height: 36px; background: #fd0000; color: #fff; border: none; border-radius: 6px; cursor: pointer;"
          @click="handleBtnClick"
        >
          {{ hasLogin ? '退出登录' : '去登录' }}
        </button>
      </div>
    </div>

    <!-- 会员信息区域（已登录用户） -->
    <div
      v-if="hasLogin"
      class="member-info-section"
    >
      <!-- Lv.0未绑定用户引导提示 - 放在签到卡片上方 -->
      <div
        v-if="showBindGuide"
        class="bind-guide-tip-compact"
      >
        <svg
          class="guide-icon-svg"
          viewBox="0 0 24 24"
          width="12"
          height="12"
        >
          <path
            fill="currentColor"
            d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
          />
        </svg>
        <span class="guide-text">
          绑定任一平台账号（适配返现），立即获得 <span class="highlight-text">10 积分</span>，升级为 <span class="highlight-text">Lv.1</span>，获取<span class="highlight-text">"布衣天子"</span>称号，解锁返现权益（限已对接平台）。
          <span
            class="guide-link"
            @click="goToBind"
          >去绑定</span>
        </span>
      </div>
      <!-- 签到进度条 + 积分称号同行 -->
      <div class="member-info-row">
        <!-- 左边：签到进度条 -->
        <div class="sign-progress-container">
          <div class="sign-progress-header">
            <span class="sign-progress-title">📅 本周签到</span>
            <span
              v-if="userStore.signStatus.continuousDays > 0"
              class="continuous-badge"
            >🔥 连续{{ userStore.signStatus.continuousDays }}天</span>
            <span
              v-if="hasContinuousStreak && nextExtraRewardDays > 0 && !userStore.signStatus.signedToday"
              class="continuous-tip-inline"
            >再签到{{ nextExtraRewardDays }}天可领连续签到奖励</span>
            <span
              v-if="!userStore.signStatus.signedToday && userStore.signStatus.continuousDays < 7"
              class="sunday-tip"
            >满7天加送2积分</span>
          </div>
          <div class="sign-progress-track">
            <!-- PC端布局（默认） -->
            <template v-if="!isMobile">
              <template
                v-for="(day, index) in weekDays"
                :key="'pc-'+index"
              >
                <!-- 圆圈和标签 -->
                <div class="sign-day-item">
                  <div class="sign-dot-wrapper">
                    <div
                      class="sign-dot"
                      :class="getDotClass(day)"
                      @click="handleDayClick(day)"
                    >
                      <span
                        v-if="day.isSigned"
                        class="check-icon"
                      >✓</span>
                      <span
                        v-else
                        class="points-text"
                      >{{ day.points }}</span>
                      <span
                        v-if="day.isSigned && !day.isSunday && !day.isSaturday"
                        class="points-tag-inline"
                      >{{ day.points }}</span>
                      <span
                        v-if="day.isSigned && !day.isSunday && day.isSaturday"
                        class="points-tag-inline-left"
                      >{{ day.points }}</span>
                      <span
                        v-if="day.canRepair"
                        class="repair-tag"
                      >补</span>
                    </div>
                    <span
                      v-if="day.isSigned && day.isSunday"
                      class="day-label signed-text signed-text-sunday"
                    >已签到</span>
                    <span
                      v-else-if="day.isSigned && index === 0"
                      class="day-label signed-text signed-text-monday"
                    >已签到</span>
                    <span
                      v-else-if="day.isSigned"
                      class="day-label signed-text"
                    >已签到</span>
                    <span
                      v-else-if="day.canRepair"
                      class="day-label can-repair"
                      @click.stop="handleRepairClick(day)"
                    >补签</span>
                    <span
                      v-else
                      class="day-label"
                    >{{ day.label }}</span>
                  </div>
                </div>
                <div
                  v-if="index < 6"
                  class="sign-connector"
                  :class="{ filled: day.isSigned && weekDays[index + 1]?.isSigned }"
                />
              </template>
            </template>
            <!-- 手机端布局 -->
            <template v-else>
              <!-- 连接线（底层）-->
              <div class="mobile-week-line">
                <div
                  v-for="i in 6"
                  :key="'line-'+i"
                  class="mobile-line-segment"
                  :class="{ filled: isMobileSegmentFilled(i - 1) }"
                  :style="{
                    left: ((i - 1) / 6 * 100) + '%',
                    width: (1 / 6 * 100) + '%'
                  }"
                />
              </div>
              <!-- 圆圈和标签（上层）-->
              <div class="mobile-week-dots">
                <div
                  v-for="(day, index) in weekDays"
                  :key="'mobile-dot-'+index"
                  class="mobile-dot-wrapper"
                  :style="{ left: (index / 6 * 100) + '%' }"
                >
                  <div
                    class="sign-dot"
                    :class="getDotClass(day)"
                    @click="handleDayClick(day)"
                  >
                    <span
                      v-if="day.isSigned"
                      class="check-icon"
                    >✓</span>
                    <span
                      v-else
                      class="points-text"
                    >{{ day.points }}</span>
                  </div>
                  <span class="day-label">{{ day.label }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- 右边：积分 + 称号 -->
        <div class="stats-panel">
          <!-- 左边：积分 + 称号 -->
          <div class="stats-left">
            <div class="stat-item stat-points">
              <span class="stat-label">💰 我的积分</span>
              <span class="stat-value">{{ userStore.userInfo.points || 0 }}</span>
            </div>
            <div class="stat-item">
              <span class="title-icon">🏆</span>
              <span class="title-label">称号：</span>
              <span
                class="level-badge"
                :class="getLevelClass(userStore.userInfo.level)"
              >
                {{ userStore.userInfo.title }}
              </span>
            </div>
          </div>

          <!-- 右边：规则+签到按钮 -->
          <div class="stats-right">
            <!-- 右上：积分明细 + 规则按钮 -->
            <div class="stats-right-top">
              <button
                class="btn-points-detail-inline"
                @click="showPointsDetail = true"
              >
                积分明细
              </button>
              <button
                class="btn-rule-circle"
                @click="showRulesDialog = true"
              >
                ?
              </button>
            </div>
            <!-- 右下：签到按钮 -->
            <div class="stats-right-bottom">
              <button
                v-if="!userStore.signStatus.signedToday"
                class="btn-sign-small"
                @click="handleSign"
              >
                🎁 点击签到
              </button>
              <button
                v-else
                class="btn-signed-small"
                disabled
              >
                ✅ 今日已签到
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 升级进度（Lv.0不显示进度条，Lv.10满级不显示） -->
      <div
        v-if="userStore.userInfo.level > 0 && userStore.userInfo.level < 10"
        class="upgrade-progress"
      >
        <div class="progress-text">
          <span>距离 Lv.{{ getNextLevel() }} 还差 {{ pointsNeeded }} 积分</span>
          <span>{{ progressPercent }}%</span>
        </div>
        <div class="progress-bar">
          <div
            class="progress-fill"
            :style="{ width: progressPercent + '%' }"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- 签到成功弹窗 -->
  <el-dialog
    v-model="showSignDialog"
    title=""
    width="320px"
    :show-close="false"
    class="sign-dialog"
  >
    <div class="sign-success-content">
      <div class="sign-icon">
        ✅
      </div>
      <div class="sign-title">
        签到成功！
      </div>
      <div class="sign-points">
        +{{ signResult.pointsEarned }} 积分
      </div>
      <div class="sign-info">
        <div>当前积分：{{ signResult.newPoints }}</div>
        <div>连续签到：{{ signResult.continuousDays }}天</div>
      </div>
      <div
        v-if="signResult.isExtraReward"
        class="extra-reward"
      >
        🏆 连续签到奖励已发放！等级提升至 Lv.{{ signResult.newLevel }} {{ signResult.newTitle }}
      </div>
      <div
        v-else-if="signResult.nextExtraRewardDays"
        class="reward-tip"
      >
        🎯 再签到{{ signResult.nextExtraRewardDays }}天可领取连续签到奖励！
      </div>
      <button
        class="btn-confirm"
        @click="showSignDialog = false"
      >
        太棒了！
      </button>
    </div>
  </el-dialog>

  <!-- 引导绑定平台弹窗 -->
  <el-dialog
    v-model="showGuideDialog"
    title=""
    width="340px"
    :show-close="true"
    class="guide-dialog"
  >
    <div class="guide-content">
      <div class="guide-icon">
        🎉
      </div>
      <div class="guide-title">
        {{ guideTitle }}
      </div>
      <div class="guide-subtitle">
        当前：{{ userStore.userInfo.title }} · {{ userStore.userInfo.points }}积分
      </div>

      <div class="guide-benefit">
        <div class="benefit-title">
          🔗 绑定任一平台账号
        </div>
        <div class="benefit-item">
          → 立即获得 10 积分
        </div>
        <div class="benefit-item">
          → 升级为 Lv.1 布衣天子
        </div>
        <div class="benefit-item">
          → 解锁全平台返现功能
        </div>
      </div>

      <div class="platform-icons">
        <span
          class="platform-icon"
          title="京东"
        >�京东</span>
        <span
          class="platform-icon"
          title="淘宝"
        >📱淘宝</span>
        <span
          class="platform-icon"
          title="天猫"
        >🏠天猫</span>
        <span
          class="platform-icon"
          title="唯品会"
        >💰唯品会</span>
        <span
          class="platform-icon"
          title="拼多多"
        >📦拼多多</span>
        <span
          class="platform-icon"
          title="抖音"
        >🎵抖音</span>
      </div>

      <button
        class="btn-confirm"
        @click="handleGuideConfirm"
      >
        {{ guideConfirmText }}
      </button>
    </div>
  </el-dialog>

  <!-- 积分规则弹窗 -->
  <el-dialog
    v-model="showRulesDialog"
    title="积分规则"
    width="700px"
    class="rules-dialog"
    :style="{ top: 'calc(50vh - 40px)', marginTop: '-500px' }"
  >
    <div class="rules-content">
      <div class="rules-section">
        <div class="rules-title">
          📋 积分获取
        </div>
        <div class="rules-item">
          注册：默认Lv.0级
        </div>
        <div class="rules-item">
          绑定任一平台账号：+10积分
        </div>
        <div class="rules-item">
          每日签到（周一~六）：+1积分
        </div>
        <div class="rules-item">
          周日签到：+2积分
        </div>
        <div class="rules-item">
          连续签到满7天（周日）：额外+2积分
        </div>
        <div class="rules-item">
          确认收货（需完成对接的购物平台）：+1积分
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          👑 会员权益
        </div>
        <div class="rules-item">
          Lv.0：可在不折不扣平台获取各大权威平台的优惠购物、活动频道、抢券秒杀等精彩内容，省钱购物。
        </div>
        <div class="rules-item">
          Lv.1~Lv.3：优惠购物。领取"布衣天子"称号，享受不折不购平台返现权益（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.4~Lv.6：优惠购物。领取"登堂入室"称号，不折不购平台返现比例增加10%（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.7~Lv.9：优惠购物。领取"富甲一方"称号，不折不购平台返现比例增加20%（需完成对接的平台）。
        </div>
        <div class="rules-item">
          Lv.10：优惠购物。领取"天下豪绅"称号，不折不购平台返现比例增加30%（需完成对接的平台）。
        </div>
        <div class="rules-item rules-note">
          * 以上会员权益解释权归不折不购平台所有，更多会员权益持续开发中~
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          ⬆️ 升级说明
        </div>
        <table class="rules-table">
          <thead>
            <tr>
              <th>等级</th>
              <th>称号</th>
              <th>积分门槛</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>Lv.0</td><td>稚子蒙学</td><td>0</td></tr>
            <tr><td>Lv.1</td><td>布衣天子</td><td>10~99</td></tr>
            <tr><td>Lv.2</td><td>布衣天子</td><td>100~299</td></tr>
            <tr><td>Lv.3</td><td>布衣天子</td><td>300~599</td></tr>
            <tr><td>Lv.4</td><td>登堂入室</td><td>600~999</td></tr>
            <tr><td>Lv.5</td><td>登堂入室</td><td>1000~1499</td></tr>
            <tr><td>Lv.6</td><td>登堂入室</td><td>1500~2499</td></tr>
            <tr><td>Lv.7</td><td>富甲一方</td><td>2500~4499</td></tr>
            <tr><td>Lv.8</td><td>富甲一方</td><td>4500~6999</td></tr>
            <tr><td>Lv.9</td><td>富甲一方</td><td>7000~9999</td></tr>
            <tr><td>Lv.10</td><td>天下豪绅</td><td>10000+</td></tr>
          </tbody>
        </table>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          🏆 补签权益
        </div>
        <div class="rules-item">
          登堂入室（Lv.4-6）：本周可补签1次
        </div>
        <div class="rules-item">
          富甲一方（Lv.7-9）：本周可补签2次
        </div>
        <div class="rules-item">
          天下豪绅（Lv.10）：本周可补签3次
        </div>
      </div>
      <div class="rules-section">
        <div class="rules-title">
          📆 签到周期
        </div>
        <div class="rules-item">
          每周一至周日为一个周期
        </div>
        <div class="rules-item">
          周日是本周最后一天
        </div>
        <div class="rules-item">
          补签仅限本周内，跨周失效
        </div>
      </div>
    </div>
  </el-dialog>

  <!-- 积分明细弹窗 -->
  <el-dialog
    v-model="showPointsDetail"
    title="积分明细"
    width="500px"
    class="points-detail-dialog"
  >
    <div class="points-detail-content">
      <div
        v-if="pointsDetailList.length === 0"
        class="points-detail-empty"
      >
        暂无积分明细记录
      </div>
      <div
        v-else
        class="points-detail-list"
      >
        <div
          v-for="item in pointsDetailList"
          :key="item.id"
          class="points-detail-item"
        >
          <div class="points-detail-info">
            <div class="points-detail-desc">
              {{ item.description }}
            </div>
            <div class="points-detail-time">
              {{ formatDetailTime(item.created_at) }}
            </div>
          </div>
          <div
            class="points-detail-change"
            :class="item.points_change > 0 ? 'positive' : 'negative'"
          >
            {{ item.points_change > 0 ? '+' : '' }}{{ item.points_change }}
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import { computed, ref, watch, onMounted, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
// 导入Pinia的userStore
import { useUserStore } from '@/store/modules/userStore'

const userStore = useUserStore()
const router = useRouter()

// 计算属性
const hasLogin = computed(() => userStore.hasLogin)

// 响应式屏幕宽度
const screenWidth = ref(typeof window !== 'undefined' ? window.innerWidth : 1200)
const handleResize = () => {
  screenWidth.value = window.innerWidth
}
onMounted(() => {
  window.addEventListener('resize', handleResize)
})
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

// 判断是否小屏（手机端布局）
const isMobile = computed(() => {
  return screenWidth.value <= 900
})

// 手机端布局的线段填充判断
const isMobileSegmentFilled = (index) => {
  if (index < 0 || index >= 6) return false
  const current = weekDays.value[index]
  const next = weekDays.value[index + 1]
  return current?.isSigned && next?.isSigned
}

// 检查是否从周一开始连续签到（无断签）
const hasContinuousStreak = computed(() => {
  const today = new Date()
  const dayOfWeek = today.getDay() // 0=周日
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const monday = new Date(today)
  monday.setDate(today.getDate() + mondayOffset)

  const formatDateStr = (d) => {
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  // 检查从周一到今天是否每天都签到了（包含今天）
  const weekSignDates = userStore.signStatus.weekSignDates || []
  const todayStr = formatDateStr(today)

  // 如果今天还没签到，检查周一到昨天的连续性
  // 如果今天已签到，检查周一到今天的连续性
  const checkUntil = userStore.signStatus.signedToday ? todayStr : formatDateStr(new Date(today.getTime() - 86400000))

  // 从周一开始逐天检查
  const checkDate = new Date(monday)
  while (formatDateStr(checkDate) <= checkUntil) {
    if (!weekSignDates.includes(formatDateStr(checkDate))) {
      return false // 有断签
    }
    checkDate.setDate(checkDate.getDate() + 1)
  }
  return true
})

// 计算还需要几天才能领取连续签到奖励
const nextExtraRewardDays = computed(() => {
  const today = new Date()
  const dayOfWeek = today.getDay() // 0=周日
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const monday = new Date(today)
  monday.setDate(today.getDate() + mondayOffset)

  const formatDateStr = (d) => {
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const weekSignDates = userStore.signStatus.weekSignDates || []
  const todayStr = formatDateStr(today)

  // 计算从周一到今天（或昨天）已签到多少天
  const checkUntil = userStore.signStatus.signedToday ? todayStr : formatDateStr(new Date(today.getTime() - 86400000))

  let signedCount = 0
  const checkDate = new Date(monday)
  while (formatDateStr(checkDate) <= checkUntil) {
    if (weekSignDates.includes(formatDateStr(checkDate))) {
      signedCount++
    }
    checkDate.setDate(checkDate.getDate() + 1)
  }

  return 7 - signedCount
})

// 解析头像
const parsedAvatarUrl = computed(() => {
  const rawAvatarId = userStore.userInfo?.avatar || userStore.userInfo?.avatarUrl || '';
  return getAvatarUrlById(rawAvatarId);
})

// 本周7天数据
const weekDays = computed(() => {
  const today = new Date()
  const dayOfWeek = today.getDay() // 0=周日
  const days = ['日', '一', '二', '三', '四', '五', '六']

  // 计算本周周一和周日
  const mondayOffset = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
  const monday = new Date(today)
  monday.setDate(today.getDate() + mondayOffset)

  // 格式化本地日期字符串（避免ISOString时区问题）
  const formatDateStr = (d) => {
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const result = []
  for (let i = 0; i < 7; i++) {
    const date = new Date(monday)
    date.setDate(monday.getDate() + i)
    const dateStr = formatDateStr(date)
    const dayOfWeekNum = date.getDay()

    // 判断这天的签到状态（使用后端返回的本周签到记录）
    const isSigned = checkDateSigned(dateStr)
    const isToday = dateStr === formatDateStr(today)

    // 周日显示+2，其他显示+1
    const points = dayOfWeekNum === 0 ? '+2' : '+1'

    // 周日特殊处理：满7天额外+2（实际拿+4），不满7天拿+2
    const isSunday = dayOfWeekNum === 0
    const continuousDays = userStore.signStatus.continuousDays || 0
    // 判断是否已满7天连续签到
    const isFullWeek = continuousDays >= 7

    // 判断是否有补签权益（Lv.4+）且还有剩余补签次数
    const userLevel = userStore.userInfo.level || 0
    const remainRepairSign = userStore.signStatus.remainRepairSign || 0
    // 只有过去的未签到日期才能补签（今天和未来日期不能补签）
    const isPastDay = !isToday && date < new Date(today.toDateString())
    const canRepair = userLevel >= 4 && remainRepairSign > 0 && !isSigned && isPastDay

    result.push({
      label: days[date.getDay()],
      date: dateStr,
      isSigned,
      isToday,
      points,
      isSunday,
      isSaturday: dayOfWeekNum === 6,
      isFullWeek,
      // 补签相关
      canRepair,
      remainRepairSign
    })
  }
  return result
})

// 检查某天是否签到
const checkDateSigned = (dateStr) => {
  // 使用后端返回的本周签到日期列表
  return userStore.signStatus.weekSignDates.includes(dateStr)
}

// 需要高亮的线段（相邻两天都签到时，它们之间的线段高亮）- 暂未使用
// const filledSegments = computed(() => {
//   const segments = []
//   for (let i = 0; i < 6; i++) {
//     const currentDay = weekDays.value[i]
//     if (currentDay && currentDay.isSigned) {
//       segments.push({ index: i })
//     }
//   }
//   return segments
// })

// 获取圆点样式
const getDotClass = (day) => {
  if (day.isSigned) return 'signed'
  if (day.isToday) return 'today'
  if (day.canRepair) return 'can-repair-dot'
  return 'future'
}

// 点击日期处理
const handleDayClick = (day) => {
  // 今天是未签到状态，点击签到
  if (day.isToday && !userStore.signStatus.signedToday) {
    handleSign()
  }
  // 有补签权益且未签到，点击补签
  else if (day.canRepair) {
    handleRepairClick(day)
  }
}

// 补签点击
const handleRepairClick = async (day) => {
  try {
    const res = await fetch('/api/users/repair-sign', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${userStore.accessToken}`
      },
      body: JSON.stringify({ repairDate: day.date })
    })
    const data = await res.json()
    if (data.code === 0) {
      ElMessage.success(`补签成功！获得 ${data.data.pointsEarned} 积分`)
      // 更新用户积分、等级和称号
      if (data.data.newPoints !== undefined) {
        userStore.userInfo.points = data.data.newPoints
      }
      if (data.data.newLevel !== undefined) {
        userStore.userInfo.level = data.data.newLevel
      }
      if (data.data.newTitle !== undefined) {
        userStore.userInfo.title = data.data.newTitle
      }
      // 刷新签到状态（包含剩余补签次数和连续天数）
      await userStore.fetchSignStatus()
      // 如果有额外奖励，提示一下
      if (data.data.isExtraReward) {
        ElMessage.success('恭喜！连续签到满7天，获得额外2积分奖励！')
      }
    } else {
      ElMessage.error(data.msg || '补签失败')
    }
  } catch (e) {
    console.error('补签失败:', e)
    ElMessage.error('补签失败，请稍后重试')
  }
}

// 升级进度
const nextLevelPoints = computed(() => {
  const level = userStore.userInfo.level || 0
  const levelConfig = {
    0: 10, 1: 100, 2: 300, 3: 600, 4: 1000,
    5: 1500, 6: 2500, 7: 4500, 8: 7000, 9: 10000
  }
  return levelConfig[level] || 10000
})

const pointsNeeded = computed(() => {
  return Math.max(0, nextLevelPoints.value - (userStore.userInfo.points || 0))
})

const progressPercent = computed(() => {
  const current = userStore.userInfo.points || 0
  const threshold = nextLevelPoints.value
  const prevThreshold = getPrevThreshold(userStore.userInfo.level || 0)
  
  // 已达等级上限
  if (userStore.userInfo.level >= 10) return 100
  
  // 已达或超过当前等级阈值（但还没升级）
  if (current >= threshold) return 99
  
  // 未达阈值，正常计算
  const progress = (current - prevThreshold) / (threshold - prevThreshold) * 100
  return Math.max(0, Math.floor(progress))
})

const getPrevThreshold = (level) => {
  const thresholds = [0, 10, 100, 300, 600, 1000, 1500, 2500, 4500, 7000, 10000]
  return thresholds[level] || 0
}

// 是否显示绑定引导
const showBindGuide = computed(() => {
  // 只有 Lv.0 且未绑定任何平台 且已登录的用户才显示引导
  return userStore.userInfo.level === 0 && hasLogin.value && userStore.userInfo.needGuideBindPlatform
})

// 弹窗状态
const showSignDialog = ref(false)
const showGuideDialog = ref(false)
const showRulesDialog = ref(false)
const showPointsDetail = ref(false)
const pointsDetailList = ref([])
const signResult = ref({})

// 引导弹窗内容
const guideTitle = ref('欢迎回来！')
const guideConfirmText = ref('朕知道了')

// 获取等级样式
const getLevelClass = (level) => {
  if (level >= 10) return 'level-10'
  if (level >= 7) return 'level-7'
  if (level >= 4) return 'level-4'
  if (level >= 1) return 'level-1'
  return 'level-0'
}

// 获取等级显示文本
const getLevelText = (level, title) => {
  return `Lv.${level} ${title}`
}

// 获取下一级等级
const getNextLevel = () => {
  return (userStore.userInfo.level || 0) + 1
}

// 获取积分明细列表
const fetchPointsDetail = async () => {
  try {
    const res = await fetch('/api/users/points-log?page=1&pageSize=50', {
      headers: {
        'Authorization': `Bearer ${userStore.accessToken}`
      }
    })
    const data = await res.json()
    if (data.code === 0) {
      pointsDetailList.value = data.data || []
    }
  } catch (e) {
    console.error('获取积分明细失败:', e)
  }
}

// 格式化时间
const formatDetailTime = (time) => {
  if (!time) return ''
  const d = new Date(time)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hour = String(d.getHours()).padStart(2, '0')
  const minute = String(d.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day} ${hour}:${minute}`
}

// 监听弹窗打开，加载积分明细
watch(showPointsDetail, (newVal) => {
  if (newVal) {
    fetchPointsDetail()
  }
})

// 头像解析
const getAvatarUrlById = (avatarId) => {
  if (!avatarId) return 'https://picsum.photos/seed/avatar/100/100'
  if (avatarId.startsWith('http')) return avatarId
  const [category, indexStr] = avatarId.split('_')
  if (!category || !indexStr) return 'https://picsum.photos/seed/avatar/100/100'
  const index = indexStr.replace(/^0+/, '') || indexStr
  try {
    return require(`@/assets/avatars/${category}/${index}.png`)
  } catch {
    return 'https://picsum.photos/seed/avatar/100/100'
  }
}

// 处理签到
const handleSign = async () => {
  const result = await userStore.doSign()
  if (result.success) {
    signResult.value = {
      pointsEarned: result.pointsEarned,
      newPoints: result.newPoints,
      continuousDays: result.continuousDays,
      isSunday: result.isSunday,
      isExtraReward: result.isExtraReward,
      newLevel: result.newLevel,
      newTitle: result.newTitle,
      nextExtraRewardDays: result.continuousDays ? (7 - result.continuousDays) : 7
    }
    showSignDialog.value = true
  } else {
    ElMessage.warning(result.msg || '签到失败')
  }
}

// 处理引导确认
const handleGuideConfirm = () => {
  showGuideDialog.value = false
  localStorage.setItem('guide_bind_platform_last_show', new Date().toDateString())
}

// 跳转到账号绑定页面
const goToBind = () => {
  router.push('/accountsetting/bind')
}

// 监听需要显示引导的情况
watch(() => userStore.userInfo.needGuideBindPlatform, (needGuide) => {
  if (needGuide && hasLogin.value) {
    const lastShow = localStorage.getItem('guide_bind_platform_last_show')
    if (lastShow !== new Date().toDateString()) {
      guideTitle.value = '欢迎回来！'
      guideConfirmText.value = '朕知道了'
      showGuideDialog.value = true
    }
  }
}, { immediate: true })

// 头像加载失败
const handleAvatarError = (e) => {
  e.target.src = 'https://picsum.photos/seed/avatar/100/100'
}

// 统一按钮点击处理
const handleBtnClick = async () => {
  if (hasLogin.value) {
    try {
      await userStore.handleLogout()
      setTimeout(() => {
        window.location.href = '/'
      }, 300)
    } catch (error) {
      ElMessage.error('退出登录失败：' + (error.message || '未知错误'))
    }
  } else {
    window.location.href = '/login'
  }
}
</script>

<style scoped>
.user-info-card {
  box-sizing: border-box;
}

/* 用户信息行 */
.user-info-row {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-avatar {
  flex-shrink: 0;
}

.user-details {
  flex: 1;
}

.user-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-nickname {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.user-phone {
  font-size: 14px;
  color: #999;
  margin-top: 5px;
}

.user-action {
  flex-shrink: 0;
  min-width: 100px;
}

/* 小屏适配 - 用户信息区域 */
@media (max-width: 900px) {
  .user-info-row {
    display: block;
    text-align: center;
  }

  .user-avatar {
    margin-bottom: 10px;
  }

  .user-details {
    margin-bottom: 10px;
  }

  .user-name-row {
    justify-content: center;
    flex-wrap: wrap;
  }

  .user-phone {
    margin-top: 5px;
  }

  .user-action {
    margin-top: 10px;
  }

  .user-action button {
    width: 100%;
  }
}

button:hover {
  opacity: 0.9;
}

/* 会员信息区域 */
.member-info-section {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}

/* 签到进度条 + 积分称号同行 */
.member-info-row {
  display: flex;
  gap: 15px;
  align-items: stretch;
  height: 76px;
}

/* 左边：签到进度条 */
.sign-progress-container {
  flex: 7;
  min-width: 420px;
  height: 100%;
  padding: 6px 12px;
  background: linear-gradient(135deg, #fff9f0, #fff);
  border-radius: 12px;
  border: 1px solid #ffe7ba;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
}

.sign-progress-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}

.sign-progress-title {
  font-weight: bold;
  color: #333;
}

.continuous-badge {
  font-size: 11px;
  color: #ff6b00;
  background: #fff0e6;
  padding: 1px 6px;
  border-radius: 8px;
}

.continuous-tip-inline {
  font-size: 11px;
  color: #888;
  margin-left: 6px;
  white-space: nowrap;
}

.sunday-tip {
  font-size: 11px;
  color: #ff6b00;
  font-weight: bold;
  margin-left: 6px;
  white-space: nowrap;
}

.sign-progress-track {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
}

.sign-day-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.sign-dot-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
}

/* 连接线段 */
.sign-connector {
  flex: 1;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  transition: background 0.3s ease;
}

.sign-connector.filled {
  background: linear-gradient(90deg, #ff6b00, #ff9a00);
}

.sign-dot {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  transition: all 0.3s ease;
  cursor: default;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.15);
  position: relative;
}

.sign-dot.signed {
  background: linear-gradient(135deg, #ff6b00, #ff9a00);
  color: #fff;
  animation: pulse 2s infinite;
}

.sign-dot.today {
  background: #fff;
  color: #ff6b00;
  border-color: #ff6b00;
  cursor: pointer;
  animation: pulse 2s infinite;
}

.sign-dot.today:hover {
  transform: scale(1.15);
}

.sign-dot.future {
  background: #f5f5f5;
  color: #999;
}

.sign-dot.can-repair-dot {
  background: #fff;
  color: #fd0000;
  border: 2px dashed #fd0000;
  cursor: pointer;
}

.sign-dot.can-repair-dot:hover {
  background: #fff0f0;
}

.repair-tag {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #fd0000;
  color: #fff;
  font-size: 8px;
  font-weight: bold;
  padding: 1px 3px;
  border-radius: 4px;
  line-height: 1;
}

.check-icon {
  font-size: 11px;
}

.points-text {
  font-size: 9px;
  font-weight: bold;
}

.today-text {
  font-size: 9px;
}

.day-label {
  margin-top: 3px;
  font-size: 10px;
  color: #999;
}

.day-label.signed-text {
  display: inline-block;
  color: #ff6b00;
  font-weight: bold;
  text-align: center;
}

.day-label.signed-text-sunday {
  /* 周日：右对齐（覆盖父容器align-items: center） */
  align-self: flex-end !important;
  text-align: right;
  margin-right: -5px;
  min-width: 30px;
}

.day-label.signed-text-monday {
  /* 周一：左对齐（覆盖父容器align-items: center） */
  align-self: flex-start !important;
  text-align: left;
  margin-left: -5px;
}

.day-label.can-repair {
  color: #fd0000;
  font-weight: bold;
  cursor: pointer;
}

.day-label.can-repair:hover {
  text-decoration: underline;
}

.points-tag {
  position: absolute;
  top: -4px;
  left: 26px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  background: #ff6b00;
  padding: 1px 4px;
  border-radius: 6px;
  white-space: nowrap;
}

.points-tag-left {
  position: absolute;
  top: -4px;
  left: -4px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  background: #ff6b00;
  padding: 1px 4px;
  border-radius: 6px;
  white-space: nowrap;
  z-index: 10;
}

.points-tag-sunday {
  position: absolute;
  top: -3px;
  left: -20px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  background: #ff6b00;
  padding: 1px 4px;
  border-radius: 6px;
  white-space: nowrap;
  z-index: 10;
}

.points-tag-inline {
  position: absolute;
  top: -4px;
  left: 22px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  background: #ff6b00;
  padding: 1px 4px;
  border-radius: 6px;
  white-space: nowrap;
}

.points-tag-inline-left {
  position: absolute;
  top: -4px;
  right: 22px;
  font-size: 9px;
  font-weight: bold;
  color: #fff;
  background: #ff6b00;
  padding: 1px 4px;
  border-radius: 6px;
  white-space: nowrap;
  z-index: 10;
}

.reward-label {
  position: absolute;
  top: -10px;
  right: 25px;
  font-size: 10px;
  font-weight: bold;
  color: #ff6b00;
  background: #fff3e6;
  padding: 2px 6px;
  border-radius: 6px;
  white-space: nowrap;
  border: 1px solid #ffe0cc;
  z-index: 10;
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 107, 0, 0.4);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(255, 107, 0, 0);
  }
}

.sign-reward-tip,
.sign-tip {
  margin-top: 6px;
  text-align: center;
  font-size: 11px;
  color: #999;
}

.sign-reward-tip {
  color: #ff6b00;
}

/* 右边：积分面板 */
.stats-panel {
  flex: 2;
  min-width: 280px;
  position: relative;
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 12px 15px;
  background: linear-gradient(135deg, #fff0f0, #fff);
  border-radius: 12px;
  border: 1px solid #ffe0e0;
  overflow: hidden;
}

.stats-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
}

.stats-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  gap: 4px;
}

.stats-right-top {
  display: flex;
  align-items: center;
  gap: 12px;
}

.stats-right-bottom {
  display: flex;
  align-items: flex-start;
}

.stat-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.stat-points {
  justify-content: flex-start;
}

.stat-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

.stat-value {
  font-size: 21px;
  font-weight: bold;
  color: #fd0000;
  line-height: 1;
  transform: translateY(-1px);
}

.title-icon {
  font-size: 14px;
}

.title-label {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  white-space: nowrap;
}

/* 签到按钮 */
.btn-sign-small {
  padding: 1px 10px;
  background: linear-gradient(135deg, #fd0000, #ff6b6b);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
  line-height: 1.8;
  margin: 0;
}

.btn-signed-small {
  padding: 1px 10px;
  background: #f0f0f0;
  color: #999;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  line-height: 1.8;
  margin: 0;
}

/* 圆形规则按钮（绝对定位在卡片右上角） */
.btn-rule-circle {
  width: 24px;
  height: 24px;
  background: #fff;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 50%;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-rule-circle:hover {
  background: #f9f9f9;
}

.level-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
}

.btn-points-detail-inline {
  display: inline-block;
  margin: 0;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: bold;
  color: #e5343d;
  background: linear-gradient(135deg, #fff0f0, #fff);
  border: 1px solid #ffc0c0;
  cursor: pointer;
  transition: all 0.2s;
  line-height: 1.8;
}

.btn-points-detail-inline:hover {
  background: linear-gradient(135deg, #ffe0e0, #fff5f5);
}

.level-0 {
  background: linear-gradient(135deg, #999, #666);
}

.level-1, .level-2, .level-3 {
  background: linear-gradient(135deg, #4a90d9, #2d5a87);
}

.level-4, .level-5, .level-6 {
  background: linear-gradient(135deg, #52c41a, #389e0d);
}

.level-7, .level-8, .level-9 {
  background: linear-gradient(135deg, #fa8c16, #d46b08);
}

.level-10 {
  background: linear-gradient(135deg, #faad14, #d48806);
}

.signed-today-text {
  font-size: 10px;
  color: #52c41a;
  text-align: center;
}

/* 升级进度 */
.upgrade-progress {
  margin: 10px 0;
}

.level-0 {
  background: linear-gradient(135deg, #999, #666);
}

.level-1, .level-2, .level-3 {
  background: linear-gradient(135deg, #4a90d9, #2d5a87);
}

.level-4, .level-5, .level-6 {
  background: linear-gradient(135deg, #52c41a, #389e0d);
}

.level-7, .level-8, .level-9 {
  background: linear-gradient(135deg, #fa8c16, #d46b08);
}

.level-10 {
  background: linear-gradient(135deg, #faad14, #d48806);
}

/* 升级进度 */
.upgrade-progress {
  margin: 10px 0;
}

.progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.progress-bar {
  height: 6px;
  background: #f0f0f0;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #fd0000, #ff6b6b);
  border-radius: 3px;
  transition: width 0.3s ease;
}

/* 绑定引导提示 */
.bind-guide-tip {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  background: linear-gradient(135deg, #fff7e6, #fff);
  border: 1px solid #ffd591;
  border-radius: 8px;
  margin: 10px 0;
}

/* 缩小版绑定提示 - 用于签到卡片上方 */
.bind-guide-tip-small {
  padding: 6px 10px;
  margin: 8px 0 0 0;
  font-size: 12px;
}

.bind-guide-tip-small .guide-icon {
  font-size: 14px;
}

.bind-guide-tip-small .guide-text {
  font-size: 12px;
}

/* 极简版绑定提示 - 更小高度，文字图标垂直对齐 */
.bind-guide-tip-compact {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  margin: -6px 0 6px 0;
  background: linear-gradient(135deg, #fff5f5, #fff);
  border-radius: 4px;
  font-size: 12px;
  border-left: 3px solid #fd0000;
}

.bind-guide-tip-compact .guide-icon-svg {
  color: #fd0000;
  flex-shrink: 0;
}

.bind-guide-tip-compact .highlight-text {
  color: #fd0000;
  font-weight: bold;
}

.bind-guide-tip-compact .guide-link {
  color: #fd0000;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}

.bind-guide-tip-compact .guide-link:hover {
  opacity: 0.8;
}

.bind-guide-tip-compact .guide-text {
  font-size: 12px;
  color: #fa8c16;
  line-height: 1.2;
}

.guide-icon {
  font-size: 18px;
  color: inherit;
}

.guide-text {
  font-size: 13px;
  color: #fa8c16;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.btn-sign {
  flex: 1;
  height: 40px;
  background: linear-gradient(135deg, #fd0000, #ff6b6b);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
}

.btn-sign-done {
  flex: 1;
  height: 40px;
  background: #f0f0f0;
  color: #999;
  border: none;
  border-radius: 8px;
  font-size: 14px;
}

.btn-bind {
  width: 100px;
  height: 40px;
  background: #fff;
  color: #fd0000;
  border: 1px solid #fd0000;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

/* 签到成功弹窗 */
.sign-success-content {
  text-align: center;
  padding: 10px 0;
}

.sign-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.sign-title {
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.sign-points {
  font-size: 28px;
  font-weight: bold;
  color: #fd0000;
  margin-bottom: 15px;
}

.sign-info {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.extra-reward {
  margin-top: 15px;
  padding: 10px;
  background: linear-gradient(135deg, #fff7e6, #fff);
  border: 1px solid #ffd591;
  border-radius: 8px;
  font-size: 13px;
  color: #fa8c16;
}

.reward-tip {
  margin-top: 15px;
  font-size: 13px;
  color: #999;
}

.btn-confirm {
  width: 100%;
  height: 44px;
  margin-top: 20px;
  background: linear-gradient(135deg, #fd0000, #ff6b6b);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}

/* 引导弹窗 */
.guide-content {
  text-align: center;
  padding: 10px 0;
}

.guide-icon {
  font-size: 48px;
  margin-bottom: 10px;
}

.guide-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
}

.guide-subtitle {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

.guide-benefit {
  text-align: left;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 10px;
  margin-bottom: 15px;
}

.benefit-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.benefit-item {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}

.platform-icons {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin: 15px 0;
}

.platform-icon {
  padding: 5px 10px;
  background: #f0f0f0;
  border-radius: 15px;
  font-size: 12px;
  color: #666;
}

/* 弹窗样式覆盖 */
:deep(.el-dialog) {
  border-radius: 12px;
}

:deep(.el-dialog__header) {
  padding: 0;
}

/* 积分规则弹窗 */
.rules-content {
  padding: 5px 0;
}

.rules-section {
  margin-bottom: 15px;
}

.rules-section:last-child {
  margin-bottom: 0;
}

.rules-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  padding-bottom: 5px;
  border-bottom: 1px solid #f0f0f0;
}

.rules-item {
  font-size: 12px;
  color: #666;
  line-height: 1.8;
  padding-left: 5px;
}

.rules-note {
  font-style: italic;
  color: #999;
  font-size: 11px;
  margin-top: 8px;
}



.rules-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  margin-top: 5px;
}

.rules-table th,
.rules-table td {
  padding: 6px 8px;
  text-align: center;
  border: 1px solid #f0f0f0;
}

.rules-table th {
  background: #fafafa;
  font-weight: bold;
  color: #333;
}

.rules-table td {
  color: #666;
}

.rules-table tbody tr:hover {
  background: #fff9f0;
}

/* 会员权益美化样式 */
.member-benefit {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 8px;
}

.benefit-level {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 10px;
  background: linear-gradient(135deg, #fff9f0 0%, #fff 100%);
  border-radius: 8px;
  border-left: 3px solid #ff6b00;
}

.level-badge {
  flex-shrink: 0;
  padding: 3px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: bold;
  color: #fff;
}

.level-0 {
  background: linear-gradient(135deg, #999, #666);
}

.level-1 {
  background: linear-gradient(135deg, #ffd700, #ff8c00);
}

.level-2 {
  background: linear-gradient(135deg, #ff6b6b, #ee5a5a);
}

.level-3 {
  background: linear-gradient(135deg, #9b59b6, #8e44ad);
}

.level-4 {
  background: linear-gradient(135deg, #3498db, #2980b9);
}

.benefit-desc {
  font-size: 12px;
  color: #555;
  line-height: 1.6;
}

.title-name {
  color: #ff6b00;
  font-weight: bold;
  padding: 0 2px;
}

/* 积分明细弹窗样式 */
.points-detail-content {
  max-height: 400px;
  overflow-y: auto;
}

.points-detail-empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}

.points-detail-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.points-detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 8px;
  border-left: 3px solid #e5343d;
}

.points-detail-info {
  flex: 1;
}

.points-detail-desc {
  font-size: 13px;
  color: #333;
  margin-bottom: 4px;
}

.points-detail-time {
  font-size: 11px;
  color: #999;
}

.points-detail-change {
  font-size: 16px;
  font-weight: bold;
  min-width: 50px;
  text-align: right;
}

.points-detail-change.positive {
  color: #e5343d;
}

.points-detail-change.negative {
  color: #52c41a;
}

/* ========== 小屏适配（手机端签到卡片风格）========== */
@media (max-width: 900px) {
  .user-info-card {
    min-width: 0 !important;
    padding: 10px;
  }

  .member-info-row {
    display: block;
    height: auto;
  }

  .sign-progress-container {
    width: 100%;
    min-width: 0;
    height: auto;
    padding: 10px;
    margin: 0 0 10px 0;
  }

  .sign-progress-header {
    flex-wrap: wrap;
    gap: 4px;
    margin-bottom: 8px;
  }

  .sign-progress-track {
    position: relative;
    height: 50px;
    margin: 0 15px;
  }

  .sign-day-item,
  .sign-connector {
    display: none;
  }

  /* 手机端风格的连接线 */
  .sign-progress-track::before {
    content: '';
    position: absolute;
    top: 8px;
    left: 15px;
    right: 15px;
    height: 2px;
    background: #e0e0e0;
  }

  /* 手机端风格的7天圆点 - 使用绝对定位 */
  .mobile-week-dots {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .mobile-dot-wrapper {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    transform: translateX(-50%);
  }

  .sign-dot {
    width: 16px;
    height: 16px;
    font-size: 9px;
  }

  .day-label {
    font-size: 11px;
    color: #999;
  }
}
</style>
